import * as React from 'react'

import Translation from '../../containers/Translation';
import { T_LOADING } from '../../api/translations';
import useTranslation from '../../hooks/useTranslation';

import('./PlayerPointsStyles.scss')   


const PlayerPointsPresentation = (props:any) => {
    const pointsText = useTranslation('StatisticsRanking_points');

    if( props.pointsHome == null || props.pointsAway == null ) {
        return (
            <div className={`player-points sr-grid sr-align-center`}>
                <div className="sr-cell sr-stats-loading"><Translation tag={T_LOADING} /></div>
            </div>
        );
    }
    return (
        <div className={`player-points sr-grid`}>
            <div className={`player left sr-cell sr-cell-align-center`}>
                <div className={`sr-content sr-align-center`}>
                    <div className={`sr-align-center point-wrapper`}>
                        <div>{props.pointsHome}</div>
                        {pointsText}
                    </div>
                </div>
            </div>
            <div className={`additional-content sr-cell sr-xs-1-3`}>
                <div className={`sr-content`}>
                    {props.children}
                </div>
            </div>
            <div className={`player right sr-cell sr-cell-align-center`}>
                <div className={`sr-content sr-align-center`}>
                    <div className={`sr-align-center point-wrapper`}>
                        <div>{props.pointsAway}</div>
                        {pointsText}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlayerPointsPresentation